window.Prism = require('prismjs/prism');
Prism.manual = true;

require('./jquery-prism');
